// Module
var code = "<header> <a class=\"validate-again\"><img class=\"loader mr-8px\" src=\"/webui/app/images/ring.gif\">Validate again</a> <h1>Table mapping validation</h1> <h3>List contains result of last validation errors.</h3> </header> <ul class=\"app-exceptions\"></ul> ";
// Exports
export default code;